import React from "react";
import { Button, Card, Col, Form, Input, Row, Select, Alert, Upload, Modal, Radio, Spin } from "antd";
const { Option } = Select;
import { LoadingOutlined, PlusOutlined, ArrowRightOutlined } from '@ant-design/icons'
import ImgCrop from 'antd-img-crop'
import api_url from '../../../utils/requestApi'
import ServerApi from '../../../utils/ServerApi'
import appConst from '../../../constents/app.const'

class DepositAction extends React.Component{
    constructor(props){
        super(props)
        this.get_method_list = this.get_method_list.bind()
    }
    formRef = React.createRef();
    state={
        authFail: false,
        authFailMsg: 'Input correct data',
        method: [],
        phone_to: '',
        phone_to_show: '',
        fileList: [],
        previewOpen: false,
        previewTitle: '',
        previewImage: '',
        w_final_amount: 0.0,
        rate: 1.0,
        depo_final_amount: 0.0,
        copy_success: false,
        loading: false
    }
    componentDidMount(){
        this.get_method_list()
    }
    get_method_list = () => {
        const serverApi = new ServerApi(appConst.apiUrl, this.props.token)
        serverApi.work_data(api_url.dep_method, returnData => {
            if(returnData.success == 1){
                this.setState({method: returnData.method})
            }else{
                this.setState({method: []})
            }
        })
    }
    get_number_list = (method_no) => {
        const serverApi = new ServerApi(appConst.apiUrl, this.props.token)
        serverApi.work_data(api_url.dep_number + method_no, returnData => {
            if(returnData.success == 1){
                this.setState({
                    phone_to: returnData.number.title,
                    phone_to_show: returnData.number.sub_title
                }, () => {
                    document.querySelector('.wd_to_number').value = returnData.number.title;
                    document.querySelector('.wd_to_number_box').style.display = 'block';
                })
            }else{
                this.setState({phone_to: '', phone_to_show: ''}, () => {
                    document.querySelector('.wd_to_number_box').style.display = 'none';
                })
            }
        })
    }
    onReset = () => {
        this.formRef.current.resetFields()
    }
    onFinish = (e) => {
        e.wd_to = this.state.phone_to;
        e.image = this.state.fileList.length==1?this.state.fileList[0].name:'';
        const serverApi = new ServerApi(appConst.apiUrl, this.props.token);
        this.setState({loading: true}, () => {
            serverApi.account_actions(api_url.dep_action, 'POST', e, returnData => {
                if(returnData.success == 1){
                    this.setState({
                        authFail: false,
                        authFailMsg: returnData.message,
                        loading: false
                    }, () => {
                        this.onReset()
                        let notify = document.querySelector('.rate-limit')
                        notify.style.display = 'none'
                    })
                }else{
                    this.setState({
                        authFail: true,
                        authFailMsg: returnData.message,
                        loading: false
                    })
                }
            })
        })
    }
    amount_keyup = (e) => {
        let notify = document.querySelector('.rate-limit')
        notify.style.display = 'block'
        this.setState({w_final_amount: e.target.value}, () => {
            this.depo_final_amountt()
        })
    }
    depo_final_amountt = () => {
        let depo_final_amount = Number(this.state.rate) * Number(this.state.w_final_amount)
        this.setState({depo_final_amount: depo_final_amount})
    }
    render(){
        const uploadButton = (
            <div>
              {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
              <div
                style={{
                  marginTop: 8,
                }}
              >
                Upload
              </div>
            </div>
        )
        const handleCancel = () => {
            this.setState({previewOpen: false})
        }
        const handlePreview = async (file) => {
            if (!file.url && !file.preview) {
              file.preview = await getBase64(file.originFileObj);
            }
            this.setState({
                previewImage: file.url || file.preview,
                previewOpen: true,
                previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
            })
        }
        const handleChange = ({fileList: newFileList}) => {
            this.setState({fileList: []}, () => {
                this.setState({fileList: newFileList})
            })
        }
        const copyPhoneNumber = () => {
            navigator.clipboard.writeText(this.state.phone_to);
            this.setState({copy_success: true}, () => {
                document.querySelector('.wd_to_number').value = this.state.phone_to;
            });
        }
        return(
            <div>
                <Row>
                    <Col xs={0} sm={0} md={0} lg={6} xl={6}></Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}
                        style={{background: 'white'}}
                    >
                        <Card>
                            <u className="ml-5"><h5>Deposit Action</h5></u>
                            {this.state.authFail ? <Alert message={this.state.authFailMsg} type="error" showIcon /> : 
                            <Alert message={this.state.authFailMsg} type="success" showIcon />}
                            <Spin tip="processing..." spinning={this.state.loading}>
                                <Form
                                    ref={this.formRef}
                                    onFinish={this.onFinish}
                                >
                                    <div className="pb-10">
                                        <label>Choose Method</label>
                                        <Form.Item name="wd_method">
                                            <Radio.Group
                                                buttonStyle="solid"
                                            >
                                                {this.state.method.map((method, index) => {
                                                    return(
                                                        <Radio.Button
                                                            key={index}
                                                            dashed
                                                            value={method.no}
                                                            style={{margin: '2px', height: '40px'}}
                                                            onClick={() => {
                                                                this.setState({
                                                                    rate: method.rate,
                                                                    copy_success: false
                                                                }, () => {
                                                                    this.get_number_list(method.no);
                                                                    this.depo_final_amountt();
                                                                });
                                                            }}
                                                        >
                                                            {method.title.includes('bKash')?<img src={"./img/method/bKash.png"} width="40"/>:(method.title.includes('Nagad')?<img src={"./img/method/Nagad.png"} width="40"/>:
                                                            (method.title.includes('Rocket')?<img src={"./img/method/Rocket.png"} width="40"/>:<img src={"./img/method/"+method.title+".png"} width="40"/>))}
                                                            <span style={{marginLeft: '2px'}}>{method.title}</span>
                                                        </Radio.Button>
                                                    )
                                                })}
                                            </Radio.Group>
                                        </Form.Item>
                                    </div>
                                    <div
                                        className="pb-10 wd_to_number_box"
                                        style={{marginTop: '5px',display: 'none'}}
                                    >
                                        <label>{this.state.phone_to_show}</label>
                                        <Row>
                                            <Col xs={19} sm={19} md={19} lg={19} xl={19}>
                                                <Form.Item name="wd_to">
                                                    <Input type="number" className="wd_to_number" disabled/>
                                                </Form.Item>
                                            </Col>
                                            <Col xs={5} sm={5} md={5} lg={5} xl={5}>
                                                <Button
                                                    dashed="true"
                                                    onClick={copyPhoneNumber}
                                                >
                                                    Copy
                                                </Button>
                                            </Col>
                                        </Row>
                                            {this.state.copy_success?<Alert message="Copied!" type="success" showIcon />:''}
                                    </div>
                                    <div className="pb-10" style={{marginTop: '10px'}}>
                                        <label>Your Number</label>
                                        <Form.Item name="wd_action">
                                            <Input type="number" placeholder="your phone number"/>
                                        </Form.Item>
                                    </div>
                                    <div className="pb-10 rate-limit" style={{display: 'none'}}>
                                        <Row style={{textAlign: 'center', color: 'green'}}>
                                            <Col xs={11} sm={11} md={11} lg={11} xl={11}>
                                                <label>Rate <br/> {this.state.w_final_amount} x {this.state.rate.toFixed(2)}</label>
                                            </Col>
                                            <Col xs={2} sm={2} md={2} lg={2} xl={2}>
                                                <label><br/><ArrowRightOutlined /></label>
                                            </Col>
                                            <Col xs={11} sm={11} md={11} lg={11} xl={11}>
                                                <label>Final Amount <br/> <b>{this.state.depo_final_amount.toFixed(2)}</b></label>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                <label style={{color: 'black'}}>Limit: <span>100</span> to <span>30000</span> </label>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="pb-10">
                                        <label>Amount</label>
                                        <Form.Item name="wd_amount">
                                            <Input type="number" placeholder="amount" onChange={this.amount_keyup}/>
                                        </Form.Item>
                                    </div>
                                    {/* <div className="pb-10">
                                        <label>Transection</label>
                                        <Form.Item name="wd_refer">
                                            <Input placeholder="transection number"/>
                                        </Form.Item>
                                    </div> */}
                                    <div className="pb-10">
                                        <label>Transection Photo</label>
                                        <Form.Item
                                            name="image"
                                            type="file"
                                        >
                                            <ImgCrop rotationSlider>
                                                <Upload
                                                    action={appConst.apiUrl+api_url.depo_img_upload_url}
                                                    headers={{
                                                        Authorization: `Bearer `+this.props.token,
                                                    }}
                                                    listType="picture-card"
                                                    fileList={this.state.fileList}
                                                    onPreview={handlePreview}
                                                    onChange={handleChange}
                                                    accept={"image/*"}
                                                >
                                                    {this.state.fileList.length == 1 ? null : uploadButton}
                                                </Upload>
                                                <Modal
                                                    open={this.state.previewOpen}
                                                    title={this.state.previewTitle}
                                                    footer={null}
                                                    onCancel={handleCancel}
                                                >
                                                    <img
                                                    alt="example"
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    src={this.state.previewImage}
                                                    />
                                                </Modal>
                                            </ImgCrop>
                                        </Form.Item>
                                    </div>
                                    <div className="pb-10">
                                        <Form.Item>
                                            <Button type="primary" htmlType="submit" block>Submit</Button>
                                        </Form.Item>
                                    </div>
                                </Form>
                            </Spin>
                        </Card>
                    </Col>
                    <Col xs={0} sm={0} md={0} lg={6} xl={6}></Col>
                </Row>
            </div>
        )
    }
}

export default DepositAction;